<template>
    <div class="relative pt-3" :class="{ 'h-56': !ready }">
        <div v-show="!ready" class="absolute inset-0 flex items-center justify-center">
            <svg class="w-10 h-10 text-blue-500 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" fill="currentColor"></path>
            </svg>
        </div>

        <div v-show="ready" class="flex flex-col space-y-6">
            <div class="mx-10 shadow drop-shadow-md filter lg:mx-20">
                <payment-request :options="paymentRequestOptions" :pk="publishableKey" @paymentResponse="closePaymentRequestAndEmitPaymentResponse">
                    <div slot="loading" class="h-10"></div>
                </payment-request>
            </div>
            <div class="flex">
                <hr class="flex-grow my-6" />
                <span class="flex-grow-0 place-self-center px-4 text-gray-400 uppercase">or pay with card</span>
                <hr class="flex-grow my-6" />
            </div>
            <stripe-element-card ref="cardRef" :pk="publishableKey" :classes="stripeElementCardClasses" @element-ready="elementReady" :disabled="processing" />
        </div>
    </div>
</template>

<script>
import { StripeElementCard } from "@vue-stripe/vue-stripe"
import PaymentRequest from "../Renderless/PaymentRequest"
import Loading from "@/Jetstream/Loading"

const publishableKey = process.env.NODE_ENV === "production" ? process.env.MIX_STRIPE_KEY : process.env.MIX_STRIPE_KEY_DEV

export default {
    name: "CreditCardForm",

    components: { Loading, StripeElementCard, PaymentRequest },

    props: {
        amount: {
            required: true,
        },
        processing: {
            default: false,
        },
    },

    computed: {
        cents() {
            return this.amount * 100
        },

        paymentRequestOptions() {
            return {
                requestPayerName: true,
                requestPayerEmail: true,
                // requestPayerPhone: true,
                requestShipping: false,
                // disableWallets: ['applePay', 'googlePay'],
                country: "US",
                currency: "usd",
                displayItems: [
                    {
                        label: this.amount + " tokens",
                        amount: this.cents,
                    },
                ],
                total: {
                    amount: this.cents,
                    label: "Planet Challenge, LLC",
                },
            }
        },
    },

    watch: {},

    data() {
        return {
            user: this.$page.props.user,
            ready: false,
            publishableKey: publishableKey,
            stripeElementCardClasses: {
                base: "shadow-sm border-2 border-gray-300 rounded-md px-5 py-3",
                empty: "border-gray-300",
                focus: "border-indigo-500",
                complete: "border-green-500",
                invalid: "border-red-500",
            },
        }
    },

    methods: {
        async submit() {
            const stripe = this.$refs.cardRef.stripe
            const card = this.$refs.cardRef.element
            const billingDetails = {
                name: this.user.name || this.user.email,
                email: this.user.email,
                phone: this.user.phone,
            }

            const paymentResponse = await stripe.createPaymentMethod({
                type: "card",
                card: card,
                billing_details: billingDetails,
            })

            if (paymentResponse) {
                this.$emit("paymentResponse", paymentResponse)
            }
        },

        closePaymentRequestAndEmitPaymentResponse(paymentResponse) {
            paymentResponse.complete("success")
            this.$nextTick(this.$emit("paymentResponse", paymentResponse))
        },

        elementReady() {
            this.ready = true
        },
    },
}
</script>
